import { SOLUTIONS_NO } from "./solutions-no";

/** Gjettbare ord – starter med løsningslisten; kan utvides */
export const WORDS_NO: string[] = [...SOLUTIONS_NO];
